Object.assign = require('object-assign')



// WEBPACK FOOTER //
// ./src/polyfills.js